export default __webpack_public_path__ + "static/media/7.98338885.jpg";